export const setSection = (payload) => ({
  type: "SET_SECTION",
  payload,
});
